import React, { useContext } from 'react'
import { ContactTab } from '../../components/ContactTab/ContactTab';
import { DocumentsTab } from '../../components/DocumentsTab/DocumentsTab';
import { EmergencyContactTab } from '../../components/EmergencyContactTab/EmergencyContactTab';
import { InformationsTab } from '../../components/InformationsTab/InformationsTab';
import { LicenceTypeTab } from '../../components/LicenceTypeTab/LicenceTypeTab';
import { MorphoTab } from '../../components/MorphoTab/MorphoTab';
import { MutationTab } from '../../components/MutationTab/MutationTab';
import { WelcomeTab } from '../../components/WelcomeTab/WelcomeTab';
import { MainContext } from '../../context/Main.context';
import { 
    ButtonsWrapper,
    ChangeTabButton,
    Form,
    FormPageWrapper,
} from './FormPage.styled';
import ArrowLeft from "../../assets/icons/arrow.left.png";
import ArrowRight from "../../assets/icons/arrow.right.png";
import { ConfirmationTab } from '../../components/ConfirmationTab/ConfirmationTab';

export const FormPage = () => {
    const {
        currentFormTab,
        handleSubmit,
        licenceType,
        setCurrentFormTab,
        submit,
        validateTab,
    } = useContext(MainContext);

    return (
        <FormPageWrapper>
            <Form onSubmit={handleSubmit(submit)}>
                <WelcomeTab />
                <LicenceTypeTab />
                <InformationsTab />
                <ContactTab />
                <EmergencyContactTab />
                <MorphoTab />
                <MutationTab />
                <DocumentsTab />
                <ConfirmationTab />
                <ButtonsWrapper>
                    <ChangeTabButton
                        type="button"
                        className={currentFormTab === -1 ? "hidden" : ""}
                        onClick={() => setCurrentFormTab(currentFormTab - 1)}
                    >
                        <img src={ArrowLeft} alt="arrow left" width="20px" />
                    </ChangeTabButton>
                    {currentFormTab === 7 ? 
                        <ChangeTabButton
                            type="submit"
                        >
                            <img src={ArrowRight} alt="arrow right" width="20px" />
                        </ChangeTabButton> :
                        <ChangeTabButton 
                            type="button"
                            className={currentFormTab === 0 && licenceType === undefined ? "hidden" : ""}
                            onClick={async () => {
                                if (await validateTab()) {
                                    setCurrentFormTab(currentFormTab + 1);
                                }
                            }}
                        >
                            <img src={ArrowRight} alt="arrow right" width="20px" />
                        </ChangeTabButton>
                    }
                </ButtonsWrapper>
            </Form>
        </FormPageWrapper>
    )
}
